import { Typography } from "@mui/material";
import DataGridView from "components/grid/DataGridView";

interface ColumnSchema {
  name: string;
  displayName: string | null;
  typeName: string;
  nullable: boolean;
}

export interface TableSchema {
  name: string;
  displayName: string | null;
  columns: (ColumnSchema | null)[] | null;
}

interface SchemaRow extends ColumnSchema {
  table: string;
}

/** Columns of a set of table schemas in a grid grouped by table. */
export default function TableSchemata({ schema }: { schema: TableSchema[] }) {
  if (!schema.length)
    return <Typography variant="body2">There are no tables.</Typography>;

  const rows: SchemaRow[] = schema.flatMap(table =>
    (table.columns ?? [])
      .filter((column): column is ColumnSchema => !!column)
      .map(column => ({
        ...column,
        table: table.displayName
          ? `${table.displayName} (${table.name})`
          : table.name
      }))
  );

  return (
    <div data-testid="table-schemata">
      <DataGridView<SchemaRow>
        dataSource={rows}
        height="auto"
        allowSelection={false}
        columns={[
          {
            colDef: {
              caption: "Table",
              dataField: "table",
              groupIndex: 0,
              autoExpandGroup: schema.length === 1
            }
          },
          { colDef: { caption: "Column", dataField: "name" } },
          { colDef: { caption: "Display name", dataField: "displayName" } },
          { colDef: { caption: "Type", dataField: "typeName" } },
          {
            colDef: {
              caption: "Nullable",
              dataField: "nullable",
              dataType: "boolean"
            }
          }
        ]}
      />
    </div>
  );
}
